import { createSlice } from '@reduxjs/toolkit'

export const configSlice = createSlice({
    name: 'config',
    initialState: {
        config: [],
        hasLoaded: false
    },
    reducers: {
        load: (state, action) => {
            state.config = action.payload
            state.hasLoaded = true
        },
    }
})
export default configSlice.reducer

export const { load } = configSlice.actions

// export const selectRepsStatus = state => state.reps.repsStatus
// export const selectAllReps = state => state.reps.reps
export const getConfig = (state) => state.config.config || [];
export const hasLoaded = (state) => state.config.hasLoaded;
// export const selectRepByID = (state, repID) => state.reps.reps.find(rep => rep.ID === repID)

